import { render, staticRenderFns } from "./SeismicRexApplicability.vue?vue&type=template&id=c8018052&scoped=true"
import script from "./SeismicRexApplicability.vue?vue&type=script&lang=ts"
export * from "./SeismicRexApplicability.vue?vue&type=script&lang=ts"
import style0 from "./SeismicRexApplicability.vue?vue&type=style&index=0&id=c8018052&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8018052",
  null
  
)

export default component.exports